import Aempty from '@/components/Aempty';
import AformItem from '@/components/AformItem';
import Apages from '@/components/Apages';
import Apopconfirm from '@/components/Apopconfirm';
import './index.css';

export default {
  name: 'Atable',
  props: {
    id: { type: String, default: () => (`a-table-${Math.random().toString().substring(2)}`) },
    rowKey: { type: String, default: () => 'id' },
    flex: { type: Boolean, default: () => false },
    edit: { type: Boolean, default: () => false },
    column: { type: Array, default: () => [] },
    record: { type: Object, default: () => ({ data: [], size: 0 }) },
    sort: { type: Object | Boolean, default: () => ({ label: '', width: 50 }) },
    selection: { type: Boolean, default: () => false },
    loading: { type: Boolean, default: () => false },
    border: { type: Boolean, default: () => false },
    sortable: { type: Boolean, default: () => false },
    showOverflowTooltip: { type: Boolean, default: () => true },
    global: { type: Boolean, default: () => true },
    pages: { type: Object | Boolean, default: () => ({}) },
  },
  data() {
    return ({
      body: null,
      height: null,
      maxHeight: null,
      active: null,
      item: null,
    });
  },
  watch: {
    column: {
      deep: true,
      immediate: true,
      handler() {
        this.relate();
      },
    },
    loading(status = false) {
      status === false && (this.active = null);
    }
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.$nextTick(() => {
        let height = this.$el.clientHeight;
        this.$nextTick(() => {
          const footer = document.getElementById(`${this.id}-pages`);
          this.$nextTick(() => {
            footer && (height = (height - footer.clientHeight));
            this.$nextTick(() => {
              this.height = Math.ceil(height);
              this.$nextTick(() => {
                this.resize();
                this.$nextTick(() => this.assign());
              });
            });
          });
        });
      });
    },
    resize(height = 0) {
      this.maxHeight = Math.ceil(this.height - height);
    },
    assign() {
      if (this.$refs.table) {
        this.body = this.$refs.table.bodyWrapper;
        this.$nextTick(() => this.body && (this.body.addEventListener('wheel', this.scroll)));
      }
    },
    scroll(a) {
      if (this.body) {
        if (this.body.scrollHeight > this.body.clientHeight) {
          a.preventDefault();
          this.body.scrollTop += a.deltaY;
        } else {
          if (this.body.scrollWidth > this.body.clientWidth) {
            a.preventDefault();
            this.body.scrollLeft += a.deltaY;
          }
        }
        this.$emit('scroll', a);
      }
    },
    relate() {
      if (this.column && (this.column.length > 0)) {
        const column = [];
        this.column.forEach((a, b) => column[b] = this.format(a, b));
        const { actionLabel = '操作', actionWidth = null, action = [] } = this.$attrs;
        const { review, modify, revise, rework, update, handle, censor, remove } = this.$listeners;
        if (review || modify || revise || rework || update || handle || censor || remove || (this.$listeners.delete || this.$listeners.export || (action && (action.length > 0)))) {
          const events = { review, modify, revise, rework, update, handle, censor, remove, delete: this.$listeners.delete, export: this.$listeners.export };
          const length = ((Object.keys(events).filter((a) => events[a]).length) + action.length);
          column[this.column.length] = (
            <el-table-column
              class-name="action"
              key="action"
              fixed="right"
              align="center"
              label={actionLabel || '操作'}
              width={actionWidth || ((length > 0) ? (((length > 1) ? (length + 1) : (length + 2)) * 48) : null)}
              formatter={(a, b, c, d) => (
                <div class="action">
                  {review && (<el-button key="review" type="text info" on-click={() => review(a, d, b, c)}>查看</el-button>)}
                  {modify && (<el-button key="modify" type="text" on-click={() => modify(a, d, b, c)}>编辑</el-button>)}
                  {revise && (<el-button key="revise" type="text" on-click={() => revise(a, d, b, c)}>修改</el-button>)}
                  {rework && (<el-button key="rework" type="text" on-click={() => rework(a, d, b, c)}>更改</el-button>)}
                  {update && (<el-button key="update" type="text" on-click={() => update(a, d, b, c)}>更新</el-button>)}
                  {handle && (<el-button key="handle" type="text warning" on-click={() => handle(a, d, b, c)}>审核</el-button>)}
                  {censor && (<el-button key="censor" type="text warning" on-click={() => censor(a, d, b, c)}>审查</el-button>)}
                  {remove && (
                    <Apopconfirm on-submit={() => remove(a, d, b, c)}>
                      <el-button key="remove" type="text danger">删除</el-button>
                    </Apopconfirm>
                  )}
                  {this.$listeners.delete && (
                    <Apopconfirm on-submit={() => this.$listeners.delete(a, d, b, c)}>
                      <el-button key="delete" type="text danger">删除</el-button>
                    </Apopconfirm>
                  )}
                  {this.$listeners.export && (<el-button key="export" type="text success" on-click={() => this.$listeners.export(a, d, b, c)}>下载</el-button>)}
                  {this.action && ((this.action.length > 0) && (this.action.map((e, f) => {
                    const label = e.label || e.title || e.text || e.name || e.key || null;
                    if (label) {
                      return (<el-button key={f} type="text" class={`action ${f}`} on-click={g => e.click(a, b, c, d, f, g)} {...e}>{label}</el-button>);
                    }
                  })))}
                </div>
              )}
            />
          );
        }
        return column;
      }
    },
    format(a, b) {
      const label = a.header || a.label || a.title || a.text || a.name || '';
      const field = a.dataIndex || a.field || a.index || a.prop || a.name || a.key || '';
      const child = a.childrens || a.children || a.columns || a.column || a.child || a.cols || [];
      const index = field.toLowerCase();
      const width = (index.endsWith('time') || index.endsWith('date')) ? (a.type ? 230 : 170) : null;
      const component = a.components || a.component || a.formatter || a.elements || a.element || a.render || a.dom || null;
      const sorted = (a.sortable || a.sorter) || (this.sortable || this.sorter) || (index.endsWith('time') || index.endsWith('date')) || null;
      const sortable = (field && (component === null)) ? sorted : null;
      const render = (row, column, cellValue, index) => {
        const { editObject = { index: undefined, value: undefined } } = this.$attrs;
        if (this.edit || (editObject && ((editObject.index !== undefined) && (editObject.index == index)))) {
          const form = editObject.value || row;
          return (<AformItem key={`${b}-${index}`} form={form} field={field} class={field} {...{ attrs: a }} />);
        } else {
          return cellValue;
        }
      };
      const formatter = (a.type && ((a.type != 'selection') && (a.type != 'index') && (a.type != 'expand'))) ? render : component;
      const attrs = {
        index: b,
        key: b,
        width,
        sortable,
        formatter,
        prop: field,
        scopedSlot: field,
        showOverflowTooltip: this.showOverflowTooltip,
        ...a
      };
      if (a.type && (a.type == 'expand')) {
        const content = a.content || a.context || a.childrens || a.children || a.child || component;
        return (<el-table-column key={b} class-name={field} label={label} {...{ attrs }}>{content}</el-table-column>);
      }
      return (
        <el-table-column key={b} class-name={field} label={label} {...{ attrs }}>
          {child && ((child.length > 0) && (child.map((c, d) => this.format(c, (`${b}-${d}`)))))}
        </el-table-column>
      );
    },
    select(rows = []) {
      const keys = [];
      rows.forEach((a, b) => keys[b] = a[this.rowKey]);
      if (this.global) {
        this.$store.commit('setSelectedKeys', keys);
        this.$store.commit('setSelectedRows', rows);
      }
      this.$emit('select', ({ rows, keys, item: this.item }));
    },
    choose(row, column, event) {
      if (row[this.rowKey] !== undefined) {
        this.active = this.active === row[this.rowKey] ? null : row[this.rowKey];
      }
      this.$emit('click', row, column, event);
      this.$emit('choose', row, column, event);
    },
    change(pages = { page: 1, size: 10 }) {
      if (this.global) {
        this.$store.commit('setPageParams', pages);
        const { pageParams = {}, formParams = {} } = this.$store.state;
        const formatParams = { ...pageParams, ...pages, ...formParams };
        this.$emit('search', formatParams);
        this.$emit('change', formatParams);
      } else {
        this.$emit('search', pages);
        this.$emit('change', pages);
      }
    },
    update(height = 0, delay = 600) {
      let timeout = null;
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      } else {
        timeout = setTimeout(() => {
          this.resize(height);
          clearTimeout(timeout);
          timeout = null;
        }, delay);
      }
    },
    revoke() {
      if (this.body) {
        this.body.removeEventListener('wheel', this.scroll);
        this.$nextTick(() => this.body = null);
      }
      this.height = null;
      this.maxHeight = null;
      this.active = null;
      this.item = null;
    },
  },
  render() {
    const { pageParams = {} } = this.$store.state;
    const { emptyText, ...attrs } = this.$attrs;
    const { select, ...on } = this.$listeners;
    const r = this.record;
    const data = r.data || r.list || r.rows || r.page || r.pages || r.source || r.record || r.records || r.dataSource || r.dataSources || [];
    const total = r.total || r.count || r.size || r.sum || r.totality || r.quantity || r.totalCount || r.totalNumber || 0;
    return (
      <div id={this.id} class={['a-table', (this.flex ? 'flex' : null)]}>
        {(this.column.length > 0) && (
          <el-table
            ref="table"
            v-loading={this.loading}
            data={data}
            max-height={this.maxHeight}
            stripe={null}
            border={this.border}
            row-class-name={({ row }) => ((row[this.rowKey] !== undefined) && (row[this.rowKey] === this.active)) ? ('a-table-row active') : ('a-table-row')}
            cell-style={{ padding: '5px 0' }}
            header-cell-style={{ padding: '2px 0' }}
            on-select={(_, item) => this.item = item}
            on-select-all={() => this.item = null}
            on-selection-change={this.select}
            row-key={this.rowKey}
            class={this.border ? null : ('no-border')}
            on-row-click={this.choose}
            {...{ attrs }}
            on={on}
          >
            {this.selection && (<el-table-column key="selection" type="selection" width={40} fixed="left" align="center" class-name="selection" />)}
            {this.sort && (<el-table-column key="sort" type="index" fixed="left" align="center" class-name="sort" attrs={this.sort} />)}
            {this.$slots.before}
            {this.$slots.front}
            {this.$slots.left}
            {this.relate()}
            {this.$slots.default}
            <div slot="empty" class="a-table-empty">{!this.loading && (<Aempty description={emptyText} />)}</div>
          </el-table>
        )}
        {this.pages && ((total !== undefined) && (
          <div id={`${this.id}-pages`} class="a-table-pages">
            <Apages padding="0" margin="0" pages={{ ...pageParams, ...this.pages }} total={parseInt(total)} on-change={this.change} />
          </div>
        ))}
      </div>
    );
  }
}